import script from "./StakeStatsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeStatsChart.vue?vue&type=script&setup=true&lang=js"

import "./StakeStatsChart.vue?vue&type=style&index=0&id=5e4ad71b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4ad71b"]])

export default __exports__